/**
 * Table Drag
 * @function tableDrag
 * @param {url} url 
 */

const tableDrag = () => {
	let mainTableContainerWidth,
		mainTableWidth,
		theTable,
		mainTableContainer,
		startX,
		scrollLeft,
		isDown = false,
		tblItems,
		allTables,
		tblClick,
		tabSect,
		tablePressTables,
		tableWrappers,
		tableWrappersA,
		tableWrappersOuter,
		tablePressTablesA,
		tableWrappersOuterA,
		mainTable,
		tblItemImgCheck;

	// detect first column of table
	mainTable = document.querySelectorAll('.tablepress');
	mainTable.forEach((table) => {
		for (let i = 0; i < table.rows.length; i++) {
			let firstCol = table.rows[i].cells[0];
			firstCol.className = 'first-col';
		}
	});

	// check if table cell has image
	tblItemImgCheck = document.querySelectorAll('.tablepress tbody td');
	tblItemImgCheck.forEach((item) => {
		if (item.innerHTML.includes('<img')) {
			item.className = 'has-image';
		}
	});

	// These are tables for posts

	tablePressTables = document.querySelectorAll(
		'.post-content-inner > .tablepress, .post-content-inner .full-main-content > .tablepress, .panel .panel-content div .tb-text > .tablepress'
	);
	tablePressTables.forEach((table) => {
		let wrapper = document.createElement('div');
		table.parentNode.insertBefore(wrapper, table);
		wrapper.classList.add('table-outer');
		wrapper.appendChild(table);
	});

	tableWrappersOuter = document.querySelectorAll(
		'.post-content-inner > .table-outer, .post-content-inner .full-main-content > .table-outer, .panel .panel-content div .tb-text > .table-outer'
	);
	tableWrappersOuter.forEach((table) => {
		let wrapper = document.createElement('div');
		table.parentNode.insertBefore(wrapper, table);
		wrapper.className = 'tbl-cont';
		wrapper.appendChild(table);

		if (window.innerWidth <= 820) {
			wrapper.style.maxWidth = window.innerWidth - 50 + 'px';
		}
	});

	tableWrappersOuter.forEach((tblClick) => {
		let wrapper = document.createElement('div');
		tblClick.parentNode.insertBefore(wrapper, tblClick);
		wrapper.className = 'tbl-click';
		wrapper.innerHTML = 'Click and drag to scroll';
	});

	tableWrappers = document.querySelectorAll(
		'.post-content-inner > .table-container, .post-content-inner .full-main-content > .table-container, .panel .panel-content div .tb-text > .table-container'
	);
	let count = 1;

	tablePressTables.forEach((wrap) => {
		let outerWrapper = document.createElement('div');
		wrap.parentNode.insertBefore(outerWrapper, wrap);
		outerWrapper.classList.add('table-container');
		outerWrapper.appendChild(wrap)
		outerWrapper.setAttribute("data-table", count);
		count++;
	});

	// if it has datatables_wrapper around it

	tablePressTablesA = document.querySelectorAll(
		'.post-content-inner > .dataTables_wrapper, .post-content-inner .full-main-content > .dataTables_wrapper, .panel .panel-content div .tb-text > .dataTables_wrapper'
	);

	tablePressTablesA.forEach((table) => {
		let wrapper = document.createElement('div');
		table.parentNode.insertBefore(wrapper, table);
		wrapper.classList.add('table-outer');
		wrapper.appendChild(table);
	});

	tableWrappersOuterA = document.querySelectorAll(
		'.post-content-inner > .table-outer, .post-content-inner .full-main-content > .table-outer, .panel .panel-content div .tb-text > .table-outer'
	);
	tableWrappersOuterA.forEach((table) => {
		let wrapper = document.createElement('div');
		table.parentNode.insertBefore(wrapper, table);
		wrapper.className = 'tbl-cont';
		wrapper.appendChild(table);
	});

	tableWrappersOuterA.forEach((tblClick) => {
		let wrapper = document.createElement('div');
		tblClick.parentNode.insertBefore(wrapper, tblClick);
		wrapper.className = 'tbl-click';
		wrapper.innerHTML = 'Click and drag to scroll';
	});

	tableWrappersA = document.querySelectorAll(
		'.post-content-inner > .table-container, .post-content-inner .full-main-content > .table-container, .panel .panel-content div .tb-text > .table-container'
	);

	let counta = 1;
	tablePressTablesA.forEach((wrap) => {
		let outerWrapper = document.createElement('div');
		wrap.parentNode.insertBefore(outerWrapper, wrap);
		outerWrapper.classList.add('table-container');
		outerWrapper.appendChild(wrap)
		outerWrapper.setAttribute("data-table", count);
		counta++;
	});

	tblItems = document.querySelectorAll(".table-container");
	allTables = document.querySelectorAll('.tbl-cont');

	const doSlider = (tblElem) => {

		if (tblElem) {
			tblElem.addEventListener('mousedown', (e) => {
				isDown = true;
				tblElem.classList.add('active');
				startX = e.pageX - tblElem.offsetLeft;
				scrollLeft = tblElem.scrollLeft;
			});

			tblElem.addEventListener('mouseleave', () => {
				isDown = false;
				tblElem.classList.remove('active');
			});

			tblElem.addEventListener('mouseup', () => {
				isDown = false;
				tblElem.classList.remove('active');
			});

			tblElem.addEventListener('mousemove', (e) => {
				if (!isDown) return;
				e.preventDefault();
				const x = e.pageX - tblElem.offsetLeft;
				const walk = (x - startX) * 3;
				tblElem.scrollLeft = scrollLeft - walk;
			});
		}
	};


	const doSlide = (tblItems) => {
		tblItems.forEach((tblElem) => {
			doSlider(tblElem);
		});
	}

	const doTables = () => {

		if (allTables !== null) {
			let count = 0;

			allTables.forEach((tblCont) => {

				tblClick = tblCont.querySelector('.tbl-click');
				theTable = tblCont.querySelector('.tablepress');
				mainTableContainer = tblCont.querySelector('.table-outer');

				if (mainTableContainer !== null) {
					mainTableContainerWidth = mainTableContainer.offsetWidth;

					if (window.innerWidth <= 820) {
						tblCont.style.maxWidth = window.innerWidth - 50 + 'px';
					} else {
						tblCont.style.maxWidth = '100%';
					}

					if (theTable) {
						mainTableWidth = theTable.scrollWidth;

						tabSect = document.querySelector('.section-1');

						if (tabSect !== null) {
							tabSect.style.display = 'none';
						}

						// Always set scroll on mobile
						if (window.innerWidth <= 820) {
							mainTableContainerWidth = window.innerWidth / 2;
						}

						if (mainTableContainerWidth >= mainTableWidth) {
							tblClick.style.display = 'none';
							mainTableContainer.classList.add('no-scroll');
						} else {
							mainTableContainer.classList.remove('no-scroll');
							tblClick.style.display = 'block';
							doSlide(tblItems);
						}
					}

					count++;
				} else {
					return;
				};
			});
		} else {
			return;
		}
	};

	const resizedw = () => {
		doTables();
	}

	let doit;
	window.onresize = function () {
		clearTimeout(doit);
		doit = setTimeout(resizedw, 100);
	};

	doTables();

	const theContainer = document.querySelector('.table-outer');
	const dataTablesFilter = document.querySelector('.dataTables_wrapper .dataTables_filter');

	const datatablesWrapper = document.querySelector('.table-container');
	const datatablesHeader = document.querySelector('.dataTables_length');
	const datatablesFooter = document.querySelector('.dataTables_paginate');
	const datatablesInfo = document.querySelector('.dataTables_info');

	if (datatablesWrapper) {

		// Move datatablesHeader above datatablesWrapper
		datatablesWrapper.parentNode.insertBefore(datatablesHeader, datatablesWrapper);

		// Move datatablesFooter below datatablesWrapper
		datatablesWrapper.parentNode.insertBefore(datatablesInfo, datatablesWrapper.nextSibling);
		datatablesWrapper.parentNode.insertBefore(datatablesFooter, datatablesWrapper.nextSibling);


		if (dataTablesFilter && theContainer) {
			var content = dataTablesFilter;
			var parent = theContainer;
			parent.insertBefore(content, parent.firstChild);

			dataTablesFilter.appendChild(tblClick);
		}
	}
};

export default tableDrag;


// 
// 

